// extracted by mini-css-extract-plugin
module.exports = {"section":"section--3G4Y1aKJ5N"};